[
  {
    "code": "GE-AB",
    "name": "Abkhazia"
  },
  {
    "code": "GE-AJ",
    "name": "Ajaria"
  },
  {
    "code": "GE-GU",
    "name": "Guria"
  },
  {
    "code": "GE-IM",
    "name": "Imeret'i"
  },
  {
    "code": "GE-KK",
    "name": "K'vemo K'art'li"
  },
  {
    "code": "GE-KA",
    "name": "Kakhet'i"
  },
  {
    "code": "GE-MM",
    "name": "Mts'khet'a-Mt'ianet'i"
  },
  {
    "code": "GE-RL",
    "name": "Racha-Lech'khumi-K'vemo Svanet'i"
  },
  {
    "code": "GE-SZ",
    "name": "Samegrelo-Zemo Svanet'i"
  },
  {
    "code": "GE-SJ",
    "name": "Samts'khe-Javakhet'i"
  },
  {
    "code": "GE-SK",
    "name": "Shida K'art'li"
  },
  {
    "code": "GE-TB",
    "name": "T'bilisi"
  }
]